import type { MedicationAgreement } from '~/models'
import { PullService } from './servicePull'
import { getDocs, limit, query, where } from 'firebase/firestore'

export class MedicationAgreementServicePull extends PullService<
  MedicationAgreement,
  MedicationAgreement[]
> {
  private readonly collection

  constructor() {
    super()
    const { collection } = useFirebase()
    this.collection = collection('MedicationAgreement')
  }

  @PullService.CallableFunction<MedicationAgreement[]>()
  public async getMedicationAgreementsByUserId(
    userId: string,
  ): Promise<MedicationAgreement[]> {
    const q = query(this.collection, where('UserId', '==', userId), limit(50))

    const snapshot = await getDocs(q)

    return snapshot.docs.map(doc => doc.data() as MedicationAgreement)
  }

  @PullService.CallableFunction<MedicationAgreement[]>()
  public async getAllOnDemandAgreementsByUserId(
    userId: string,
  ): Promise<MedicationAgreement[]> {
    const q = query(this.collection, where('UserId', '==', userId), where('AdminAgreementSummary.OnDemand', '==', true), limit(50))

    const snapshot = await getDocs(q)

    return snapshot.docs.map(doc => doc.data() as MedicationAgreement)
  }
}
